import React from 'react'
import cn from 'classnames'
import { IconButton } from '..'

export const pagination = (maxPages: number, currentPage: number): number[] => {
  const pagesVisible = 3
  const allPages = Array.from(Array(maxPages).keys())
  if (currentPage - 1 === -1) {
    // start state
    return allPages.slice(0, pagesVisible)
  } else if (currentPage + 1 === maxPages) {
    // end state
    return allPages.slice(allPages.length - pagesVisible, allPages.length)
  } else {
    return allPages.slice(currentPage - 1, currentPage + 2)
  }
}

export type PaginationControlsProps = {
  max: number
  next: () => void
  prev: () => void
  page: number
  goToPage: (pageNumber: number) => void
}

const PaginationControls = ({ max, next, prev, page, goToPage }: PaginationControlsProps) => {
  const PaginationLink = ({ pageNumber, className = '' }: { pageNumber: number; className?: string }) => {
    return (
      <button
        className={cn(
          'pagination__link',
          {
            'pagination__link--currentPage': pageNumber === page
          },
          className
        )}
        onClick={() => goToPage(pageNumber)}
      >
        <h5>{pageNumber + 1}</h5>
      </button>
    )
  }

  return (
    <div className='d-flex align-items-center pagination mt-3'>
      {page !== 0 && (
        <span>
          <IconButton style={{ transform: 'rotate(180deg)' }} type='modalArrow' onClick={prev} />
        </span>
      )}
      {page > 1 && (
        <>
          <span>
            <PaginationLink pageNumber={0} />
          </span>
          {page > 2 && (
            <span>
              <h5 className=' pagination__dots'>...</h5>{' '}
            </span>
          )}
        </>
      )}
      {pagination(max, page).map((p, i) => (
        <span key={i}>
          <PaginationLink pageNumber={p} />
        </span>
      ))}
      {page < max - 2 && (
        <>
          {page < max - 3 && (
            <span>
              <h5 className='pagination__dots'>...</h5>{' '}
            </span>
          )}
          <span>
            <PaginationLink pageNumber={max - 1} />
          </span>
        </>
      )}
      {page + 1 !== max && (
        <span>
          <IconButton type='modalArrow' onClick={next} />
        </span>
      )}
    </div>
  )
}

export default PaginationControls
